export const LoginTranslations = {
  LOGIN_EMAIL_INPUT: 'Email address',
  LOGIN_PASSWORD_INPUT: 'Password',
  LOGIN_BUTTON_TEXT: 'Login',

  LOGIN_NO_SUGARDADDY_ERROR_TITLE: 'Whoops',
  LOGIN_NO_SUGARDADDY_ERROR_MESSAGE: 'Are you sure you are the companies sugardaddy?'
};
